import { BasicDialogModal } from '@ingenico/react-ui/basic-dialog-modal';
import { CoreButton } from '@ingenico/react-ui/core-button';
import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { UnblockDeviceModalProps } from './UnblockDeviceModal.model';
import styles from './UnblockDeviceModal.module.scss';

export function UnblockDeviceModal({
  isOpen,
  isLoading,
  onUnblockDevice,
  onCancel,
}: UnblockDeviceModalProps): ReactNode {
  const { t } = useTranslation([ALL_LNGS_NAMESPACES.LOGICAL_DEVICE]);

  return (
    <BasicDialogModal
      actions={
        <div className={styles.modalActions}>
          <CoreButton disabled={isLoading} onClick={onCancel} variant="text">
            {t('button.cancel', { ns: ALL_LNGS_NAMESPACES.COMMON })}
          </CoreButton>
          <CoreButton
            loading={isLoading}
            onClick={() => {
              void onUnblockDevice();
            }}
            variant="contained"
          >
            {t('button.unblockDevice', { ns: ALL_LNGS_NAMESPACES.LOGICAL_DEVICE })}
          </CoreButton>
        </div>
      }
      customPaperClassName={styles.paperContainer}
      customActionsClassName={styles.customActionsClassName}
      isOpen={isOpen}
      onClose={onCancel}
      title={t('unblockDeviceModal.title', { ns: ALL_LNGS_NAMESPACES.LOGICAL_DEVICE })}
      subTitle={t('unblockDeviceModal.subtitle', { ns: ALL_LNGS_NAMESPACES.LOGICAL_DEVICE })}
    />
  );
}
